import { faqs, offer, stats } from './content'
import type { FaqItem, Stat } from './content'

export const kitHero = {
  subheadline: '100 map wizualnych + 6 profesjonalnych zestawów gotowych do użycia',
  description:
    '100 gotowych wyjaśnień dla klientów, 24 sesje do dopasowania i 50 błędów z praktycznymi korektami. Wszystko uporządkowane — mniej improwizacji, więcej pewności.',
}

export const kitStats: Stat[] = stats.map((stat) =>
  stat.label === 'Praktycznych bonusów' ? { ...stat, label: 'Profesjonalnych zestawów' } : stat,
)

export interface Kit {
  number: string
  title: string
  hook: string
  description: string
}

export const kitsCopy = {
  title: 'To nie wszystko: dostajesz też 6 profesjonalnych zestawów gotowych do użycia.',
  subtitle:
    'Nie tylko mapy do przeglądania. Sześć praktycznych narzędzi, dzięki którym wytłumaczysz ćwiczenia, przygotujesz sesje i uporządkujesz pracę z klientami.',
  badge: 'W pakiecie',
  closing:
    'Od wyjaśnienia ćwiczenia po pierwszą sesję z nowym klientem: sześć narzędzi do pracy z większym porządkiem i mniejszą improwizacją.',
  closingNote: 'Wszystkie 6 zestawów jest w pełnym pakiecie.',
}

export const kits: Kit[] = [
  {
    number: '01',
    title: '100 gotowych wyjaśnień dla klienta',
    hook: 'Właściwe słowa, by wytłumaczyć każde ćwiczenie.',
    description:
      '100 uporządkowanych wyjaśnień: zaangażowane mięśnie, technika i praktyczne wskazówki. Otwórz kartę i dopasuj ją do klienta.',
  },
  {
    number: '02',
    title: 'Matryca zamienników ćwiczeń',
    hook: 'Znajdź właściwy zamiennik bez zaczynania od zera.',
    description:
      'Gotowa matryca wariantów uporządkowanych według wzorca ruchu, poziomu i dostępnego sprzętu.',
  },
  {
    number: '03',
    title: '24 sesje gotowe do dopasowania',
    hook: 'Koniec z zaczynaniem od pustej kartki.',
    description:
      '24 karty z ćwiczeniami, seriami, powtórzeniami i gotową kolejnością. Wybierz sesję i dopasuj ją do klienta.',
  },
  {
    number: '04',
    title: 'Ekspresowe korekty: 50 typowych błędów',
    hook: 'Rozpoznajesz błąd. Wiesz, na co patrzeć i co poprawić.',
    description:
      '50 częstych błędów technicznych z praktycznymi wskazówkami, które pomogą ci jaśniej wytłumaczyć korektę.',
  },
  {
    number: '05',
    title: 'Karty klienta i monitorowanie postępów',
    hook: 'Mniej luźnych kartek. Więcej kontroli nad postępami.',
    description:
      'Gotowe szablony do zapisywania treningów, ciężarów, powtórzeń i postępów twoich klientów.',
  },
  {
    number: '06',
    title: 'Pierwsza sesja bez improwizacji',
    hook: 'Pierwsze spotkanie — już zaplanowane.',
    description:
      'Checklista, karta celów i struktura pierwszego spotkania, żeby pewniej przyjmować nowych klientów.',
  },
]

export interface KitOfferRow {
  title: string
  detail: string
}

export const kitOffer = {
  label: 'Kompletny pakiet dla trenera personalnego',
  name: 'Wizualny Atlas Biomechaniki Ćwiczeń',
  summary: '100 map wizualnych + 6 profesjonalnych zestawów',
  status: 'W pakiecie',
  bundle: '1 kompletny Atlas + 6 profesjonalnych zestawów',
  bundleNote: 'Wszystko uporządkowane. Jeden zakup. Bez abonamentu.',
  priceLabel: 'Cały system za jedyne',
  price: offer.price,
  currency: offer.currency,
  priceNote: 'Jednorazowa płatność. Dostęp na zawsze.',
  cta: 'Tak, chcę cały system',
  note: 'Bezpieczna płatność · Natychmiastowe pobranie · 7 dni gwarancji',
  closing:
    '100 przeanalizowanych ćwiczeń i 6 narzędzi gotowych do pracy. Wszystko w jednym pakiecie cyfrowym.',
}

export const kitOfferRows: KitOfferRow[] = [
  {
    title: 'Wizualny Atlas — 100 map ćwiczeń',
    detail: 'Mięśnie, technika, płaszczyzny anatomiczne, typowe błędy i warianty.',
  },
  {
    title: 'Zestaw: wyjaśnienia i zamienniki',
    detail: '100 gotowych wyjaśnień + matryca zamienników ćwiczeń.',
  },
  {
    title: 'Zestaw: sesje i korekty',
    detail: '24 sesje do dopasowania + 50 błędów technicznych z praktycznymi wskazówkami.',
  },
  {
    title: 'Zestaw: klienci i pierwsza sesja',
    detail: 'Karty monitorowania + narzędzia do zaplanowania pierwszego spotkania.',
  },
  {
    title: 'Pełny dostęp cyfrowy',
    detail: 'PDF do druku · Natychmiastowy dostęp · Dostęp na zawsze.',
  },
]

export const kitFinalCta = {
  title: '100 przeanalizowanych ćwiczeń. 6 gotowych zestawów. Jeden system.',
  subtitle:
    'Wszystkie informacje i narzędzia, których potrzebujesz, żeby tłumaczyć ćwiczenia, przygotowywać sesje i porządkować pracę z klientami — w jednym pakiecie.',
  summary: '100 map wizualnych + 6 profesjonalnych zestawów',
  cta: 'Chcę cały system',
}

export const kitFaqs: FaqItem[] = faqs.map((faq) =>
  faq.question === 'Czy zawiera gotowe plany treningowe?'
    ? {
        question: 'Czy zawiera gotowe sesje treningowe?',
        answer:
          'Tak. W zestawie znajdziesz 24 uporządkowane sesje, które możesz wykorzystać jako punkt wyjścia i dopasować do każdego klienta. Nie są to plany spersonalizowane i nie zastępują twojej profesjonalnej oceny.',
      }
    : faq,
)
